import { CFImage } from '../type/client-index'

type OtherClient_t = CFImage & { featured?: boolean }

export const easyclothes: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/19bd574f-560e-4ad4-49a2-c0b10e289a00/square',
  width: 1500,
  height: 1500,
  featured: true
}

export const exception: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/e677e9f2-12ef-4c3e-4886-346ec9397f00/square',
  width: 1500,
  height: 1500
}

export const maisonCollette: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/f9fb1665-c50f-4992-ba1c-8f794fa42700/square',
  width: 1500,
  height: 1500
}

export const camilleBE: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/41984fe4-a357-487f-96aa-f03d7cb55600/square',
  width: 1500,
  height: 1500
}

export const oliveAntwerpLogo: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/0537edf6-0b6b-4eee-9abc-f40118755c00/square',
  width: 1500,
  height: 1500
}

export const chronoPack: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/f81dfcd3-eb5b-40a4-f421-2d5cb0e94900/square',
  width: 1500,
  height: 1500
}

export const inspire: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/c15c727c-3260-4798-4aa1-cd8c4e0c8800/square',
  width: 1500,
  height: 1500
}

export const maw: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/7740e2b8-dfa7-44c1-e453-3ea589ee8800/square',
  width: 1500,
  height: 1500,
  featured: true
}

export const pierreAuge: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/f85c599e-a68a-49ea-affe-a952005d3400/square',
  width: 1500,
  height: 1500,
  featured: true
}

export const room260: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/39e34381-5d68-482d-a1ab-168e29fffe00/square',
  width: 1500,
  height: 1500
}

export const paternotte: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/067808a1-b614-4f2a-33d9-5491e6ef1e00/square',
  width: 1500,
  height: 1500
}

export const amstrong: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/041d3d28-60dd-43d4-311e-bfe2f6c58000/square',
  width: 1500,
  height: 1500
}

export const toisondor: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/a26dd09f-3338-4bff-ce71-7ce43e956f00/square',
  width: 1500,
  height: 1500,
  featured: true
}

export const storeach: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/5ff313af-fc59-4bcf-7a0e-22580b2f2100/square',
  width: 1500,
  height: 1500
}

export const theajewlry: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/a6f8a527-80f5-4249-14fc-5d018adb4900/square',
  width: 1500,
  height: 1500,
  featured: true
}

export const nicole: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/991eb322-9d53-4101-c33d-ccbbfe858500/square',
  width: 1500,
  height: 1500
}

export const feww: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/c746dea2-dcd9-467e-35c9-e8e1b783e400/square',
  width: 1500,
  height: 1500
}

export const darovia: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/9b1ada58-766e-43b3-63a5-4ca3c410df00/square',
  width: 1500,
  height: 1500
}

export const avie: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/848ded84-3c73-4b8a-2c5c-fbee1e574700/square',
  width: 1500,
  height: 1500
}

export const seem: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/5e11c065-37b8-4c63-16ce-1cba6eb1e700/square',
  width: 1500,
  height: 1500
}

export const amo: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/37ca76c2-4c6e-4503-3c85-e8e9006aea00/square',
  width: 1500,
  height: 1500
}

export const jeanaveze: OtherClient_t = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/e08aabea-5ea5-49d2-dfa1-d52d3da29500/square',
  width: 1500,
  height: 1500
}
